// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"bfde6a4c","285":"bbb767f2","422":"7756ed7a","453":"8bd57a59","511":"771eedd6","676":"26cf558f","727":"7c638058","734":"23b3eefd","759":"04d3ee70","823":"68924619","953":"0ac0bd89"}[chunkId] + ".chunk.js";
};